import { FC, useState } from "react";

import StudentDetails from "../../forms/StudentDetails";
import { IStudentData } from "../../../../interfaces/student";
import { EtyStudent } from "../../../../interfaces/entities";

interface IStudentDetail {
  loading: boolean,
  student: EtyStudent | null,
  studentId: number | null,
};

const ProfileEditPage: FC<IStudentDetail> = (props) => {
  const { loading, student, studentId } = props

  const [formData, setFormData] = useState<IStudentData>({
    id: null,
    applicant_id: { value: "", error: "" },
    first_name: { value: "", error: "" },
    middle_name: { value: "", error: "" },
    last_name: { value: "", error: "" },
    personal_email: { value: "", error: "" },
    edu_email: { value: "", error: "" },
    phone: { value: "", error: "" },
    birth_date: { value: "", error: "" },
  });

  return (
    <div className="immersion__profile__page_view">
      <div className="immersion__common_details__layout">
        <div className="immersion__common_details__content">
          <StudentDetails
            operation={"create"}
            isLoading={loading}
            studentData={student ?? null}
            formData={formData}
            setFormData={setFormData}
            studentId={studentId ?? null}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileEditPage;
